export enum ControlButtonText {
  HOLD = 'Hold',
  RESUME = 'Resume',
  MUTE = 'Mute',
  UNMUTE = 'Unmute',
  END = 'End',
  MASK = 'Mask',
  UNMASK = 'Unmask',
  RECORD = 'Record',
  RECORDING = 'Recording',
  TRANSFER = 'Transfer',
}
